export default __webpack_public_path__ + "media/color/nmr-7eed86f9.svg";